import { render, staticRenderFns } from "./NavigationView.vue?vue&type=template&id=515376d1&scoped=true"
import script from "./NavigationView.vue?vue&type=script&lang=js"
export * from "./NavigationView.vue?vue&type=script&lang=js"
import style0 from "./NavigationView.vue?vue&type=style&index=0&id=515376d1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515376d1",
  null
  
)

export default component.exports